// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_Int from "@rescript/runtime/lib/es6/Stdlib_Int.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";

function gatewayUrl() {
  return Stdlib_Option.getOrThrow(import.meta.env["VITE_GATEWAY_URL"], undefined);
}

function posGatewayUrl() {
  return Stdlib_Option.getOrThrow(import.meta.env["VITE_POS_GATEWAY_URL"], undefined);
}

function analyticsUrl() {
  return Stdlib_Option.getOrThrow(import.meta.env["VITE_ANALYTICS_URL"], undefined);
}

function cavavinUrl() {
  return Stdlib_Option.getOrThrow(import.meta.env["VITE_CAVAVIN_URL"], undefined);
}

function sheetUrl() {
  return Stdlib_Option.getOrThrow(import.meta.env["VITE_SHEET_URL"], undefined);
}

function pdfUrl() {
  return Stdlib_Option.getOrThrow(import.meta.env["VITE_PDF_URL"], undefined);
}

function sentryDsn() {
  return import.meta.env["VITE_SENTRY_DSN"];
}

function appCommitSha() {
  return import.meta.env["VITE_APP_COMMIT_SHA"];
}

function appForceUserReloadRevision() {
  return Stdlib_Option.flatMap(import.meta.env["VITE_APP_FORCE_USER_RELOAD_REVISION"], __x => Stdlib_Int.fromString(__x, undefined));
}

function intercomAppID() {
  return "m4f5bzdq";
}

function postHogAppKey() {
  return "phc_hesp7A4JQKciBO9H7krMBC9Hm6Ru71HmAqmR2rZyAQD";
}

function context() {
  if (Stdlib_Option.isSome(import.meta.env["VITEST"])) {
    return "test";
  }
  let match = import.meta.env["VITE_CONTEXT"];
  if (match === undefined) {
    return "dev";
  }
  switch (match) {
    case "production" :
      return "production";
    case "staging" :
      return "staging";
    default:
      return "dev";
  }
}

export {
  gatewayUrl,
  posGatewayUrl,
  analyticsUrl,
  cavavinUrl,
  sheetUrl,
  pdfUrl,
  sentryDsn,
  appCommitSha,
  appForceUserReloadRevision,
  intercomAppID,
  postHogAppKey,
  context,
}
/* No side effect */
